module.exports = __webpack_public_path__ + "img/product_1.ed08ee7d.png";